var p = /* @__PURE__ */ ((x) => (x.xxs = "16px", x.xs = "16px", x.s = "16px", x.m = "20px", x.l = "24px", x.xl = "32px", x.xxl = "32px", x))(p || {}), r = /* @__PURE__ */ ((x) => (x.xxs = "16px", x.xs = "20px", x.s = "24px", x.m = "32px", x.l = "48px", x.xl = "64px", x.xxl = "72px", x))(r || {});
export {
  r as E,
  p as S
};
